import React, { memo } from "react";

import type { MessageBoxConfig, WidgetRenderType } from "@intelligems/ig-types";

import { MessageBoxContextProvider } from "./context/MessageBoxContextProvider";
import { MessageBoxFactory } from "./MessageBoxFactory";
import { resolveMessageBoxConfig } from "./resolveMessageBoxConfig";

export interface MessageBoxViewProps {
  config: MessageBoxConfig;
  renderType: WidgetRenderType;
  isFe?: boolean;
  onClose?: () => void;
  visible?: boolean;
}

export const MessageBoxView = memo((props: MessageBoxViewProps) => {
  const { desktop, mobile } = React.useMemo(
    () => resolveMessageBoxConfig(props.config.widget),
    [props.config]
  );

  switch (props.renderType) {
    case "all":
      return (
        <MessageBoxContextProvider {...props} widget={desktop} hasMediaQuery>
          <MessageBoxFactory />
        </MessageBoxContextProvider>
      );
    case "desktop":
      return (
        <MessageBoxContextProvider {...props} widget={desktop}>
          <MessageBoxFactory />
        </MessageBoxContextProvider>
      );
  }
});
